// RIMUOVE BACKDROP DEI MODAL PER EVITARE FREEZE PAGINA
document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("hidden.bs.modal", function (e) {
        // e.target è il modal che si è appena chiuso
        const backdrops = document.querySelectorAll(".modal-backdrop");
        const body = document.body;

        // Rimuove tutti i backdrop
        backdrops.forEach((backdrop) => {
            if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
            }
        });

        // Ripristina il body
        body.classList.remove("modal-open");
        body.style.overflow = "auto";
        body.style.paddingRight = "";
    });
});

// RIMUOVE ATTRIBUTI da CKEDITOR per visualizzare immagini embedded correttamente
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".ck-content img").forEach((img) => {
        img.classList.add("w-100");
        img.removeAttribute("width");
        img.removeAttribute("height");
    });
    document
        .querySelectorAll(".ck-content img.image_resized")
        .forEach((img) => {
            img.classList.remove("w-100");
            img.removeAttribute("width");
            img.removeAttribute("height");
        });
});
// ANIMAZIONI FADE IN con OBSERVER
// Aspetta che il DOM sia completamente caricato
document.addEventListener("DOMContentLoaded", function () {
    // Configurazione dell'Observer
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Aggiunge la classe per triggerare l'animazione SOLO per questo elemento
                    entry.target.classList.add("animate-now");
                    // Smette di osservare solo questo elemento dopo che è diventato visibile
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0.1, // Trigger quando il 20% dell'elemento è visibile
            rootMargin: "0px 0px -50px 0px", // Trigger 50px prima che entri completamente
        }
    );

    // Seleziona TUTTI gli elementi con le classi di animazione
    const animatedElements = document.querySelectorAll(
        ".fade-in-left, .fade-in-right, .fade-in-up"
    );

    // console.log(`Trovati ${animatedElements.length} elementi da animare`);

    // Osserva OGNI singolo elemento individualmente
    animatedElements.forEach((element, index) => {
        // console.log(`Osservando elemento ${index + 1}:`, element);
        observer.observe(element);

        // A fine animazione rimuove le classi di animazione: altrimenti
        // animation-fill-mode: both mantiene il transform finale del keyframe,
        // che ha priorità sul CSS e impedisce al :hover (transform) di funzionare.
        element.addEventListener("animationend", function () {
            element.classList.remove(
                "animate-now",
                "fade-in-left",
                "fade-in-right",
                "fade-in-up"
            );
        });
    });
});

// Video Player integrato in CKEditor
document.addEventListener("DOMContentLoaded", () => {
    // Trova tutti gli elementi <oembed>
    const embeds = document.querySelectorAll("oembed[url]");

    embeds.forEach((embed) => {
        const url = embed.getAttribute("url"); // Ottieni l'URL del video
        const videoId = url.split("v=")[1]; // Estrai l'ID del video da YouTube

        // Crea il div con l'iframe richiesto da Plyr
        const wrapper = document.createElement("div");
        wrapper.setAttribute("class", "plyr__video-embed");

        wrapper.innerHTML = `
            <iframe
                src="https://www.youtube.com/embed/${videoId}"
                allowfullscreen
                allowtransparency
                allow="autoplay"
            ></iframe>
        `;

        // Sostituisci l'elemento <oembed> con il wrapper
        embed.replaceWith(wrapper);
    });

    // Inizializza Plyr sui video creati, ma solo se un video c'e' davvero:
    // senza <oembed> in pagina non c'e' niente da inizializzare e la libreria
    // (110 KB) non va nemmeno scaricata.
    if (embeds.length) {
        window.loadPlyr().then((Plyr) => {
            new Plyr(".plyr__video-embed", {
                controls: ["play", "progress", "volume", "fullscreen"],
            });
        });
    }
});

// Blocco l'evento prinicpale (<a>) quando apro un tooltip
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
    });
});

/* Toggle hamburger navbar */
$("#hamburger").on("click", function () {
    $(this).toggleClass("is-active");
});

/* Gestione Avvisi */
$("#close_avviso").on("click", function () {
    $("#avviso").css("display", "none");
    setCookie("avviso", 1, 1);
});

initAvviso();

function initAvviso() {
    var avviso = getCookie("avviso");
    if ($("#avviso").length > 0) {
        if (avviso == 1) {
            $("#avviso").css("display", "none");
        } else {
            $("#avviso").css("display", "block");
        }
    }
}

/* Gestione Popup */
$("#close_popup").on("click", function () {
    $("#popup").css("display", "none");
    setCookie("popup", 1, 1);
});

initPopup();

function initPopup() {
    var popup = getCookie("popup");
    if ($("#popup").length > 0) {
        var modal_popup = new bootstrap.Modal(document.getElementById("popup"));
        if (popup == 1) {
            modal_popup.hide();
        } else {
            modal_popup.show();
        }
    }
}

/* Inizializza Tooltip Bootstrap */
const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

/* Hack per svuotare i form dll'interno dei modal una volta che si ritorna dalla thankyou page */
document.querySelectorAll(".modal").forEach(function (modal) {
    modal.addEventListener("show.bs.modal", function () {
        // Reset del form se si torna indietro nel browser
        if (window.performance.navigation.type === 2) {
            const form = this.querySelector("form");
            if (form) form.reset();
        }
        // Assicurati che il primo elemento interattivo abbia focus
        const focusable = this.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable) focusable.focus();

        // Rimuovi eventuali backdrop o classi residue
        document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
        document.body.classList.remove("modal-open");
    });
});

/* Funzione Sroll_To Top page */
$(".go-to-top-page").click(function (e) {
    e.preventDefault();
    $("html, body").animate(
        {
            scrollTop: 0,
        },
        "fast"
    );
    return false;
});

/* Scroll orizzontale con la rotella del mouse sui contenitori che sbordano
   (pill delle serie nell'header). Aggiungere qui altri selettori se serve. */
const SCROLLER_ORIZZONTALE = ".series-links";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SCROLLER_ORIZZONTALE).forEach((scroller) => {
        scroller.addEventListener(
            "wheel",
            (e) => {
                // niente da scrollare (o contenitore nascosto): la rotella resta alla pagina
                const maxScroll = scroller.scrollWidth - scroller.clientWidth;
                if (maxScroll <= 1) return;

                // gesture già orizzontale (trackpad o shift+rotella): ci pensa il browser
                if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

                // deltaMode: 0 = pixel, 1 = righe, 2 = pagine
                let step = e.deltaY;
                if (e.deltaMode === 1) step *= 16;
                else if (e.deltaMode === 2) step *= scroller.clientWidth;

                // a fine corsa restituisce la rotella alla pagina invece di bloccarla
                const atStart = scroller.scrollLeft <= 0;
                const atEnd = scroller.scrollLeft >= maxScroll - 1;
                if ((step < 0 && atStart) || (step > 0 && atEnd)) return;

                e.preventDefault();
                // instant: lo scroll-behavior smooth del CSS renderebbe gommosa la rotella
                scroller.scrollBy({ left: step, behavior: "instant" });
            },
            { passive: false }
        );
    });
});

/* Menu brands mobile e ricerca */
$("*[data-open-sub]").click(function () {
    var classe = $(this).attr("data-open-sub");
    var closeother = $(this).attr("data-closeother");
    if ($(this).hasClass("active")) {
        $("." + classe).slideToggle();
        $(".notactive").removeClass("active");
    } else {
        $(this).toggleClass("active");
        $(".notactive").not($(this)).removeClass("active");
        $("." + classe).slideDown("fast");
        $("." + closeother).slideUp("fast");
        $(".closesub")
            .not("." + classe)
            .slideUp("fast");
        $("." + classe).toggleClass("show");
    }
});
